/**
 * Check if person is 18 years or older
 * @param  {String} value | input value
 * @param {Object} options
 * @returns {String|null} returns null which validates as true in validate.js or an error string
 */
const isEighteen = function (value, options) {
  if (!value) return null
  const [day, month, year] = value.split('-')
  const is18OrOlder =
    new Date(parseInt(year, 10) + 18, parseInt(month, 10) - 1, parseInt(day, 10)) <= new Date()
  if (day && month && year && !is18OrOlder) {
    return options.message
  }
  return null
}
export default isEighteen
